import React, { memo } from 'react';
import PropTypes from 'prop-types';

import DmListItemContents from './dm-list-item-contents';

import styles from './dm-list-item.scss';

const DmListItem = ({
  afterList = null,
  beforeList = null,
  border = false,
  children,
  className,
  onClick = null,
  onMouseEnter = null,
  onMouseLeave = null,
  secondaryText = null,
  ...passThroughProps
}) => {

  return (
    <li
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={styles.listItemWrap}
    >
      <DmListItemContents
        afterList = {afterList}
        beforeList = {beforeList}
        border = {border}
        children = {children}
        className = {className}
        onClick = {onClick}
        secondaryText = {secondaryText}
        {...passThroughProps}
      />
    </li>
  );
};

DmListItem.propTypes = {
  afterList: PropTypes.node,
  beforeList: PropTypes.node,
  border: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  secondaryText: PropTypes.string
};

export default memo(DmListItem);
